// Keep shared layout wrappers, but render content immediately without scroll observers.
export const FadeUp = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <div className={className} {...rest}>
    {children}
  </div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <span className="block">
      {children}
    </span>
  </span>
);

export const SectionHead = ({ eyebrow, title, align = "left", children }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <FadeUp>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-neon mb-5 flex items-center gap-3">
        <span className="w-2 h-2 rounded-full bg-neon inline-block pulse-dot" data-testid="section-eyebrow-dot" />
        {eyebrow}
      </p>
    </FadeUp>
    <FadeUp delay={0.08}>
      <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.08]">
        {title}
      </h2>
    </FadeUp>
    {children && (
      <FadeUp delay={0.16}>
        <div className="mt-5 text-mist text-base leading-relaxed">{children}</div>
      </FadeUp>
    )}
  </div>
);

export const Reveal = { FadeUp, MaskedLine, SectionHead };
export default Reveal;
